module.exports = __webpack_public_path__ + "img/hosting1.f5610050.png";